<template>
<div>
    <b-modal :title="advocate.name + ' - ' + (advocate.active ? 'ACTIVE' : 'INACTIVE')"
        header-bg-variant="success"
        header-text-variant="light"
        size="lg"
        :visible="true"
        centered
        @hide="modalClose"
        ok-only
    >
      <b-row>
          <b-col>
              <b-form>
                <b-form-group label="Advocate Name" label-class='addpersonlabel' label-for='Advocate Name'>
                    <b-form-input size="lg" type="text" name="Advocate Name" v-model="advocate.name" v-validate="'required'"/>
                    <span v-show="inputValidationErrors.has('Advocate Name')" class="text-info">{{ inputValidationErrors.first('Advocate Name') }}</span>
                </b-form-group>
                <b-form-group label="Organization"
                    label-class="addpersonlabel"
                    label-for="Organization">
                    <b-form-select
                      id="organization"
                      v-validate="'required'"
                      data-vv-name="Organization"
                      data-vv-as="Organization"
                      :options="organizationOptions"
                      v-model="advocate.organization">
                    </b-form-select>
                    <span v-show="inputValidationErrors.has('Organization')" class="text-info">{{ inputValidationErrors.first('Organization') }}</span>
                </b-form-group>
                <b-form-group v-if="advocate.organization === 'Other'"
                    label="Other Organization"
                    label-for="Other Organization">
                    <b-form-input size="lg" type="text" name="Other Organization" v-model="advocate.organization_otherText" v-validate="'required'"/>
                    <span v-show="inputValidationErrors.has('Other Organization')" class="text-info">{{ inputValidationErrors.first('Other Organization') }}</span>
                </b-form-group>
                <b-form-group label="Email" label-class='addpersonlabel' label-for='Email'>
                    <b-form-input size="lg" type="text" name="Email" v-model="advocate.email" v-validate="'required'"/>
                    <span v-show="inputValidationErrors.has('Email')" class="text-info">{{ inputValidationErrors.first('Email') }}</span>
                </b-form-group>
                <b-form-group label="Phone" label-class='addpersonlabel' label-for='phone'>
                    <b-form-input size="lg" type="text" name="phone" v-model="advocate.phone"/>
                </b-form-group>
            </b-form>
          </b-col>
          <b-col :key="componentKey">
            <ShareAdvocateList
              :advocateId="advocate.id"
              :advocateOrganizationOwner="advocate.organizationOwner.id"
              :personId="advocate.person"
            ></ShareAdvocateList>

            <b-card no-body>
              <b-card-body>
                <p class="card-text">
                  <small class="text-muted text-uppercase font-weight-bold">First Recorded</small>
                  <br/>
                  <small class="text-muted"><b> on: </b> {{ (advocate.createdAt/1000) | unixToHuman }}
                    <div v-if="_.isObject(advocate.createdBy)">
                      <b> by: </b> {{ _.get(advocate, 'createdBy.emailAddress', '') }}
                    </div>
                  </small>
                </p>
                <p class="card-text">
                  <small class="text-muted text-uppercase font-weight-bold">Last Updated</small>
                  <br/>
                  <small class="text-muted"><b> on: </b> {{ (advocate.updatedAt/1000) | unixToHuman }}
                    <div v-if="_.isObject(advocate.updatedBy)">
                      <b> by: </b> {{ _.get(advocate, 'updatedBy.emailAddress', '') }}
                    </div>
                  </small>
                </p>
                <p class="card-text">
                  <small class="text-muted text-uppercase font-weight-bold">Current Record Owner</small>
                  <br/>
                  <small class="text-muted"><b> by: </b> {{ _.get(advocate, 'organizationOwner.title') }} </small>
                </p>
              </b-card-body>
            </b-card>
          </b-col>
      </b-row>
      <template #modal-footer>
          <div class="w-100">
              <b-button
                variant="outline-primary"
                size="sm"
                class="float-left"
                :disabled="!isAllowedToCreateOrEditPerson"
                @click="showDeleteAdvocateModal = true">
                Delete
              </b-button>
              <b-button
                  variant="outline-primary"
                  size="sm"
                  class="float-right"
                  :disabled="!isAllowedToCreateOrEditPerson"
                  @click="updateAdvocate">
                  Update
              </b-button>
              <b-button
                  variant="primary"
                  size="sm"
                  style="margin-right: 5px"
                  class="float-right"
                  :disabled="!isAllowedToCreateOrEditPerson"
                  @click="showToggleActiveModal = true">
                  {{ advocate.active ? 'Deactivate' : 'Reactivate' }}
              </b-button>
          </div>
      </template>
    </b-modal>
    <b-modal
        :visible="showToggleActiveModal"
        ref="toggleActiveModal"
        centered
        :title="advocate.active ? 'Deactivate Advocate' : 'Reactivate Advocate'"
        size="lg"
        ok-title="No, return to Advocate"
        :cancel-title="advocate.active ? 'Yes, deactivate' : 'Yes, reactivate'"
        header-bg-variant="success"
        header-text-variant="light"
        class="tos-modal"
        hide-header-close
        no-close-on-backdrop
        @ok="showToggleActiveModal = false"
        @cancel="toggleAdvocateActiveStatus"
    >
      <p>
        Are you sure you want to
          {{advocate.active ? 'deactivate' : 'reactivate'}}
        this advocate?
        This information will be saved in the person record as an
        {{advocate.active ? 'inactive advocate' : 'active advocate'}}.
      </p>
    </b-modal>
     <b-modal
        :visible="showDeleteAdvocateModal"
        ref="deleteAdvocateModal"
        centered
        title="Delete Advocate"
        size="lg"
        ok-title="No, return to Advocate"
        cancel-title="Yes, delete"
        header-bg-variant="success"
        header-text-variant="light"
        class="tos-modal"
        hide-header-close
        no-close-on-backdrop
        @ok="showDeleteAdvocateModal = false"
        @cancel="deleteAdvocate"
    >
      <p>
        Are you sure you want to delete this advocate? This information will be removed from the person record.
      </p>
    </b-modal>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShareAdvocateList from '@/components/Advocate/ShareAdvocateList'

export default {
  name: 'view-advocate-modal',
  props: {
    viewAdvocate: Object,
    isAllowedToCreateOrEditPerson: {
      type: Boolean,
      default: false
    },
    personId: Number,
    person: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    ShareAdvocateList
  },
  computed: {
    ...mapGetters({
      userCurrentContext: 'userCurrentContext', // Passing user context to determine if they have isOrgAdmin
      advocates: 'shareAdvocateRecords',
      organizations: 'getAllOrganizations'
    }),

    organizationOptions: function () {
      let isAdvocateOrgIncluded = false
      const advocateOrg = this.viewAdvocate.organization
      const advocateOrgId = advocateOrg ? advocateOrg.id : 'Other'
      let organizationList = this.organizations
        .filter((org) => org.mailingStateAbbreviation === this.personState)
        .map(org => {
          if (!isAdvocateOrgIncluded && org.id === advocateOrgId) {
            isAdvocateOrgIncluded = true
          }
          return { value: org.id, text: org.title }
        })

      if (!isAdvocateOrgIncluded && advocateOrgId !== 'Other') {
        organizationList.push({ value: advocateOrgId, text: this.advocateOrgTitle || '' })
      }

      organizationList = _.sortBy(organizationList, 'title')
      return [...organizationList, { value: 'Other', text: 'Other' }]
    }
  },
  data: function () {
    return {
      componentKey: 0,
      organizationOwner: 0,
      showToggleActiveModal: false,
      showDeleteAdvocateModal: false,
      personState: '',
      advocate: '',
      advocateOrgTitle: ''
    }
  },
  watch: {
    advocates: function (newValue, oldValue) {
      if (newValue && newValue[0]) {
        this.organizationOwner = newValue[0].sadvocate.organizationOwner
      }
    }
  },
  methods: {
    modalClose: function () {
      this.$emit('modalClose')
    },
    forceRerender: function () {
      this.componentKey += 1
    },
    toggleAdvocateActiveStatus () {
      this.$store.dispatch('updateAdvocate', {
        id: this.advocate.id,
        data: {
          active: !this.advocate.active
        }
      }).then(() => {
        this.$emit('modalClose')
      })
    },
    updateAdvocate () {
      this.$validator.validate().then((res) => {
        if (res) {
          this.$store.dispatch('updateAdvocate', {
            id: this.advocate.id,
            data: {
              name: this.advocate.name,
              organization: this.advocate.organization === 'Other' ? null : this.advocate.organization,
              organization_otherText: this.advocate.organization === 'Other' ? this.advocate.organization_otherText : '',
              email: this.advocate.email,
              phone: this.advocate.phone
            }
          })
          this.showToggleActiveModal = false
          this.$emit('modalClose')
        }
      })
    },
    deleteAdvocate () {
      this.$store.dispatch('deleteAdvocate', {
        id: this.advocate.id,
        data: {}
      })
      this.showDeleteAdvocateModal = false
      this.$emit('modalClose')
    }
  },
  async created () {
    this.advocate = _.cloneDeep(this.viewAdvocate)
    const org = this.advocate.organization
    if (!org) {
      this.advocate.organization = 'Other'
    } else {
      this.advocate.organization = org.id || org
    }
    this.advocateOrgTitle = this.advocate.organization === 'Other' ? this.advocate.organization_otherText : org.title

    this.advocate.person = this.personId
    const owningOrg = this.person.organizationOwner
    if (owningOrg) {
      this.personState = owningOrg.mailingStateAbbreviation
    }

    await this.$store.dispatch('getOrganizations', {
      filters: {
        excludeTestOrg: true
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/t1/ViewAdvocateModal.vue